<template>
    <div class="panel-item-wrap" @click="handleCli">
        <div v-if="picsLen" class="panel-image">
            <div v-if="picsLen > 1" class="multi-pics flex-style">
                <img :src="item.games_icon[upperIndex]" :class="['upper', animStart ? 'upper-anim' : '']">
                <img :src="item.games_icon[underIndex]" :class="['under', animStart ? 'under-anim' : '']">
            </div>
            <div v-if="picsLen === 1" class="single-pics flex-style">
                <img :src="item.games_icon[0]">
            </div>
        </div>
        <div class="panel-info">
            <div class="panel-info-title">
                <span :style="{color: item.left_title_color}">{{ item.left_title }}</span>
                <span :style="{color: item.right_title_color}">{{ item.right_title }}</span>
            </div>
            <div class="panel-info-desc">{{ item.subtitle }}</div>
        </div>
        <div class="panel-btn flex-style">
            {{ item.btn_txt }}
        </div>
        <img
            :src="close"
            class="panel-close"
            @click.stop="closePanel"
        >
        <div v-if="item.tieba_pack_info && !isIOS" class="panel-bottom-firm">
            <div class="firm">{{ item.tieba_pack_info.dev }}</div>
        </div>
        <div v-if="item.tieba_pack_info && !isIOS" class="panel-bottom-right">
            <div class="edition">v{{ item.tieba_pack_info.version }}</div>
            <div class="privacy">
                <!-- eslint-disable-next-line max-len -->
                <span @click.stop="jumpPage(item.tieba_pack_info.privacy)">隐私</span>和<span @click.stop="jumpPage(item.tieba_pack_info.permission)">权限</span>
            </div>
        </div>
    </div>
</template>

<script>
import close from 'public/assets/imgs/float-panel-close.png';
import {copy, isIOS} from '@/utils/browser';
export default {
    components: {
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            count: 0,
            close: close,
            animStart: true,
            isIOS: isIOS(),
        };
    },
    computed: {
        picsLen() {
            return this.item.games_icon?.length || 0;
        },
        upperIndex() {
            this.triggerAnim();
            return this.picsLen && this.count % this.picsLen;
        },
        underIndex() {
            return this.picsLen && (this.count + 1) % this.picsLen;
        },
    },
    created() {
        setInterval(() => {
            this.count++;
        }, 2000);
        this.$root.sendLog('display', 'receivePage_display');
    },
    methods: {
        jumpPage(url) {
            setTimeout(() => {
                location.href = url;
            }, 200);
        },
        closePanel() {
            this.$root.isShowTbFloatPanel = false;
        },
        triggerAnim() {
            this.animStart = true;
            setTimeout(() => {
                this.animStart = false;
            }, 600);
        },
        handleCli() {
            this.$root.sendLog('click', 'receiveButton_click');
            copy(this.item.token);
            setTimeout(() => {
                this.$emit('handleCli', this.item.link, {}, this.item.token);
            }, 100);
        },
    },
};

</script>

<style lang="scss" scoped>
.flex-style {
    display: flex;
    align-items: center;
    justify-content: center;
}
.panel-item-wrap {
    height: 284px;
    padding: 45px 51px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: -16px;
    .panel-image {
        width: 164px;
        display: flex;
        justify-content: center;
        margin-right: 46px;
        .multi-pics {
            img {
                border: 3px solid rgba(255,255,255,1);
                border-radius: 21px;
            }
            .upper {
                width: 123px;
                height: 164px;
                z-index: 1;
                &-anim {
                    animation: upperAnim .2s linear;
                }
            }
            .under {
                width: 98px;
                height: 131px;
                margin-left: -57px;
                z-index: 0;
                opacity: 0.5;
                &-anim {
                    animation: underAnim .2s linear;
                }
            }
            @keyframes upperAnim {
                0% {
                    opacity: 0.5;
                    position: relative;
                    right: -40px;
                    transform: scale(0.8, 0.8);
                }
                100% {
                    opacity: 1;
                    position: relative;
                    right: 0;
                    transform: scale(1, 1);
                }
            }
            @keyframes underAnim {
                0% {
                    position: relative;
                    right: -20px;
                    transform: scale(0, 0);
                }
                100% {
                    position: relative;
                    right: 0;
                    transform: scale(0.8, 0.8);
                }
            }
        }
        .single-pics {
            img {
                width: 117px;
                border: 3px solid rgba(255,255,255,1);
                border-radius: 21px;
            }
        }
    }
    .panel-info {
        width: 500px;
        &-title {
            font-size: 48px;
            font-weight: 500;
            margin-bottom: 10px;
        }
        &-desc {
            font-size: 39px;
            color: #858585;
            font-weight: 400;
        }
    }
    .panel-btn {
        margin-left: auto;
        width: 282px;
        height: 93px;
        line-height: 45px;
        background-color: #EFF6FF;
        font-size: 45px;
        color: #3388FF;
        font-weight: 400;
        border-radius: 46.5px;
    }
    .panel-close {
        position: absolute;
        top: 40px;
        right: 30px;
        width: 30px;
        height: 30px;
    }
    .panel-bottom-firm {
        font-family: PingFangSC-Regular;
        font-size: 33px;
        color: #A8A8A8;
        font-weight: 400;
        position: absolute;
        bottom: 0;
        left: 51px;
    }
    .panel-bottom-right {
        font-family: PingFangSC-Regular;
        font-size: 33px;
        color: #A8A8A8;
        font-weight: 400;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        right: 51px;
        .edition {
            margin-right: 10px;
        }
        .privacy {
            margin-left: auto;
            span {
                text-decoration: underline;
            }
        }
    }
}
</style>